export interface JobDie {
  die_id     : string,
  code       : string,
  name       : string,
  template_id: string,
  tph        : string
};


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/models/jobDie.model.ts